(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fairplay-contact-blocks"] && !Shopify.designMode) return;
  try {
    
  // Client feedback, 18 Aug 2026: clicking an enquiry email "does nothing".
  //
  // The markup was already a correct mailto: anchor and nothing on the page
  // cancels the click - measured, defaultPrevented came back false on all
  // four, with Klaviyo/Selleasy/Evey all loaded. So the navigation IS being
  // handed to the browser and dropped somewhere past it, which is what a
  // machine with no registered mail handler does.
  //
  // The anchor is deliberately left alone: no preventDefault, href intact.
  // Anyone WITH a mail client keeps exactly the behaviour they had, and
  // right-click > Copy email address plus the screen-reader "link, mail"
  // announcement keep working. This only adds a second outcome on top, so
  // the click always resolves to something the visitor can see.
  (() => {
    if (window.fairplayContactCopyBound) return;
    window.fairplayContactCopyBound = true;

    const RESET_MS = 2400;

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const link = target.closest('.fairplay-contact-blocks a[href^="mailto:"]');
      if (!link) return;

      // Strip the scheme and any ?subject= tail to get the bare address.
      const address = link.getAttribute('href').slice(7).split('?')[0];
      if (!address) return;

      const status = document.querySelector('[data-fairplay-copy-status]');

      const acknowledge = (state, message) => {
        link.dataset.copied = state;
        if (status) status.textContent = message;
        clearTimeout(Number(link.dataset.copyTimer));
        link.dataset.copyTimer = String(
          setTimeout(() => {
            delete link.dataset.copied;
            delete link.dataset.copyTimer;
            if (status) status.textContent = '';
          }, RESET_MS)
        );
      };

      // Clipboard unavailable or refused (insecure context, permission
      // denied, older browser). Selecting the address is the fallback: the
      // highlight is itself visible feedback and leaves a manual copy one
      // keystroke away, so the click still resolves to something rather
      // than reproducing the dead click this exists to fix.
      const selectAddress = () => {
        try {
          const range = document.createRange();
          range.selectNodeContents(link);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          acknowledge('selected', address + ' selected, press copy to save it');
        } catch (error) {
          /* nothing further to offer; the mailto has already run */
        }
      };

      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        selectAddress();
        return;
      }

      navigator.clipboard
        .writeText(address)
        .then(() => acknowledge('true', address + ' copied to clipboard'))
        .catch(selectAddress);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
